module.exports = __webpack_public_path__ + "static/media/lpi05.9af19205.jpg";